import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import H1 from '../images/h1.jpeg';
import s from '../images/salzer.jpg';
import gm from '../images/gm.jpg';
import legrand from '../images/legrand.jpg';
import goldmedal from '../images/goldmedal1.jpg';
import { 
  faAngleLeft, 
  faChevronDown, 
  faChevronUp, 
  faFile, 
  faBook, 
  faVideo, 
  faTag, 
  faPaperPlane, 
  faBuilding,
  faFileAlt,
  faPlayCircle,
  faListAlt,
  faPhone,
  faBox,
  faFilePdf
} from '@fortawesome/free-solid-svg-icons';

const ProjectQuotes = ({ onBack }) => {
    const navigate = useNavigate();
  const [expandedBrands, setExpandedBrands] = useState({
    ultratech: true,
    acc: false,
    ambuja: false,
    share: false
  });

  const [expandedSections, setExpandedSections] = useState({
    quotations: false,
    catalogs: false,
    videos: false,
    priceLists: false
  });

  const toggleBrand = (brand) => {
    setExpandedBrands(prev => ({
      ...prev,
      [brand]: !prev[brand]
    }));
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const brands = [
    {
      id: 'legrand',
      name: 'Legrand',
      status: 'responded',
      documents: 'Quote Received',
      images: [{ uri: legrand }],
      sections: {
        quotations: [
          { id: 1, name: 'Electrical Wires Order - Project Quote' }
        ],
        catalogs: [
          { id: 1, name: 'Legrand Electrical Wires Catalog' }
        ],
        videos: [
           { id: 1, name: 'Electrical Wire intro and preview.' },
          { id: 2, name: 'Quality Standards & Testing' }
        ],
        priceLists: [
          { id: 1, name: 'Regional Price List 2025' }
        ]
      }
    },
    {
      id: 'gm',
      name: 'GM',
      images: [{ uri: gm }],
      status: 'waiting',
      message: 'Waiting for brand response'
    },
    {
      id: 'goldmedal',
      name: 'Goldmedal',
      images: [{ uri: goldmedal }],
      status: 'request',
      message: 'Request quotation to receive pricing details'
    },
    {
      id: 'salzer',
      name: 'Salzer',
      images: [{ uri: s }],
      status: 'request',
      message: 'Request quotation to receive pricing details'
    }
  ];

  const sectionIcons = {
    quotations: faFileAlt,
    catalogs: faBook,
    videos: faPlayCircle,
    priceLists: faListAlt
  };

  const sectionColors = {
    quotations: 'text-blue-500',
    catalogs: 'text-purple-500',
    videos: 'text-red-500',
    priceLists: 'text-green-500'
  };

 
  return (
    <div className="min-h-screen bg-gray-50 max-w-4xl mx-auto">
      {/* Header */}
      <div className="flex items-center gap-3 py-2 px-2 border-b border-gray-200 shadow-sm bg-white sticky top-0 z-10">
        <button
            onClick={() => navigate('/consumer/app/materiallist')}
          className="p-1 rounded-full  transition-colors"
        >
          <FontAwesomeIcon icon={faAngleLeft} className="text-xl text-gray-700" />
        </button>
        <div className='flex flex-col'>
          <h1 className="text-sm text-gray-600">RFQ-0001</h1>
          <div className='flex flex-row'>
          <p className="text-lg  text-gray-900 tracking-tight">Electrical Wires</p>
          <div className='ml-2 bg-gray-100 px-1 py-0.5 rounded-md'>
   <span className="  text-xs font-semibold text-black">Project Quantity</span>
   </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-4 space-y-4">
        {/* Status Indicators */}
        <div className="flex gap-6 px-2">
          <div className="flex items-center">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span className="ml-2 mr-1 text-sm font-semibold text-gray-900">1</span>
            <span className="text-sm text-gray-600">Responded</span>
          </div>

          <div className="flex items-center">
            <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
            <span className="ml-2 mr-1 text-sm font-semibold text-gray-900">3</span>
            <span className="text-sm text-gray-600">Waiting</span>
          </div>

          <div className="flex items-center">
            <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
            <span className="ml-2 mr-1 text-sm font-semibold text-gray-900">2</span>
            <span className="text-sm text-gray-600">Available</span>
          </div>
        </div>
        <div className='px-2'>
          <FontAwesomeIcon icon={faBox} className="text-gray-400 mr-2" />
          <span className="text-sm text-gray-600">25 Items</span>
        </div>

        {/* Brands List */}
        <div className="space-y-3">
          {brands.map((brand) => (
            <div key={brand.id} className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
              {/* Brand Header */}
              <div 
                className="flex justify-between items-center p-4 cursor-pointer"
                onClick={() => toggleBrand(brand.id)}
              >
                <div className="flex items-center gap-3">
                  <div className='w-8 h-8 bg-gray-100 rounded-md'>
                     <img
                    src={brand.images?.[0]?.uri || '/placeholder-image.jpg'}
                    alt="Material requirement"
                    className="w-full h-full object-cover"
                  />
                  </div>
                  <div className="flex flex-col">
                    <span className="font-semibold text-gray-900">{brand.name}</span>
                    {brand.status === 'responded' && (
                      <span className="text-xs text-gray-500">{brand.documents}</span>
                    )}
                  </div>
                </div>
                <FontAwesomeIcon 
                  icon={expandedBrands[brand.id] ? faChevronUp : faChevronDown} 
                  className="text-gray-400"
                />
              </div>

              {/* Expanded Brand Content */}
              {expandedBrands[brand.id] && (
                <div className="px-4 pb-4 border-t border-gray-100">
                  {brand.status === 'responded' ? (
                    <>
                      {/* Responded Sections */}
                      <div className="space-y-3 mt-3">
                        {/* Quotations Section */}
                        <div className="border border-gray-200 rounded-xl overflow-hidden">
                          <div 
                            className="flex justify-between items-center p-3 bg-gray-50 cursor-pointer"
                            onClick={() => toggleSection('quotations')}
                          >
                            <div className="flex items-center gap-3">
                              <FontAwesomeIcon 
                                icon={sectionIcons.quotations} 
                                className={`${sectionColors.quotations} text-lg`}
                              />
                              <div>
                                <h3 className="font-semibold text-gray-900">Quotations</h3>
                                <p className="text-xs text-gray-500">{brand.sections.quotations.length} item</p>
                              </div>
                            </div>
                            <FontAwesomeIcon 
                              icon={expandedSections.quotations ? faChevronUp : faChevronDown} 
                              className="text-gray-400"
                            />
                          </div>
                          
                          {expandedSections.quotations && (
                            <div className="p-3 bg-white border-t border-gray-200">
                              {brand.sections.quotations.map((item) => (
                                <div key={item.id} className="flex items-center gap-3 py-2">
                                  <FontAwesomeIcon icon={faFilePdf} className="text-gray-400 w-6" />
                                  <span className="text-sm text-gray-600 flex-1">{item.name}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        
                        {/* Price Lists Section */}
                        <div className="border border-gray-200 rounded-xl overflow-hidden">
                          <div 
                            className="flex justify-between items-center p-3 bg-gray-50 cursor-pointer"
                            onClick={() => toggleSection('priceLists')}
                          >
                            <div className="flex items-center gap-3">
                              <FontAwesomeIcon 
                                icon={sectionIcons.priceLists} 
                                className={`${sectionColors.priceLists} text-lg`}
                              />
                              <div>
                                <h3 className="font-semibold text-gray-900">Price Lists</h3>
                                <p className="text-xs text-gray-500">{brand.sections.priceLists.length} item</p>
                              </div>
                            </div>
                            <FontAwesomeIcon 
                              icon={expandedSections.priceLists ? faChevronUp : faChevronDown} 
                              className="text-gray-400"
                            />
                          </div>
                          
                          {expandedSections.priceLists && (
                            <div className="p-3 bg-white border-t border-gray-200">
                              {brand.sections.priceLists.map((item) => (
                                <div key={item.id} className="flex items-center gap-3 py-2">
                                  <span className="text-sm font-semibold text-gray-700 w-6">{item.id}</span>
                                  <span className="text-sm text-gray-600 flex-1">{item.name}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Catalogs Section */}
                        <div className="border border-gray-200 rounded-xl overflow-hidden">
                          <div 
                            className="flex justify-between items-center p-3 bg-gray-50 cursor-pointer"
                            onClick={() => toggleSection('catalogs')}
                          >
                            <div className="flex items-center gap-3">
                              <FontAwesomeIcon 
                                icon={sectionIcons.catalogs} 
                                className={`${sectionColors.catalogs} text-lg`}
                              />
                              <div>
                                <h3 className="font-semibold text-gray-900">Catalogs</h3>
                                <p className="text-xs text-gray-500">{brand.sections.catalogs.length} item</p>
                              </div>
                            </div>
                            <FontAwesomeIcon 
                              icon={expandedSections.catalogs ? faChevronUp : faChevronDown} 
                              className="text-gray-400"
                            />
                          </div>
                          
                          {expandedSections.catalogs && (
                            <div className="p-3 bg-white border-t border-gray-200">
                              {brand.sections.catalogs.map((item) => (
                                <div key={item.id} className="flex items-center gap-3 py-2">
                                  <span className="text-sm font-semibold text-gray-700 w-6">{item.id}</span>
                                  <span className="text-sm text-gray-600 flex-1">{item.name}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Videos Section */}
                        <div className="border border-gray-200 rounded-xl overflow-hidden">
                          <div 
                            className="flex justify-between items-center p-3 bg-gray-50 cursor-pointer"
                            onClick={() => toggleSection('videos')}
                          >
                            <div className="flex items-center gap-3">
                              <FontAwesomeIcon 
                                icon={sectionIcons.videos} 
                                className={`${sectionColors.videos} text-lg`}
                              />
                              <div>
                                <h3 className="font-semibold text-gray-900">Videos</h3>
                                <p className="text-xs text-gray-500">{brand.sections.videos.length} item</p>
                              </div>
                            </div>
                            <FontAwesomeIcon 
                              icon={expandedSections.videos ? faChevronUp : faChevronDown} 
                              className="text-gray-400"
                            />
                          </div>
                          
                          {expandedSections.videos && (
                            <div className="p-3 bg-white border-t border-gray-200">
                              {brand.sections.videos.map((item) => (
                                <div key={item.id} className="flex items-center gap-3 py-2">
                                  <span className="text-sm font-semibold text-gray-700 w-6">{item.id}</span>
                                  <span className="text-sm text-gray-600 flex-1">{item.name}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                      </div>

                      {/* Talk to Brand Button */}
                      <button className="w-full bg-gray-800 text-white py-3 rounded-xl font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 mt-4">
                        <FontAwesomeIcon icon={faPhone} />
                        Talk to {brand.name}
                      </button>
                    </>
                  ) : (
                    /* Waiting/Request Brand Content */
                    <div className="py-3">
                      <p className="text-sm text-gray-600 mb-3">{brand.message}</p>
                      {brand.status === 'request' && (
                        <button className="w-full bg-gray-900 text-white py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors">
                          Request Quote
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectQuotes;